import React from 'react';

import Span from 'components/elements/span';
import colors from 'styles/themes/colors';

const WithNewLabel: React.FC<{ isNew?: boolean; children?: any }> = ({
  isNew,
  children,
}) => {
  return (
    <>
      {isNew && (
        <Span
          marginRight={2}
          textTransform="uppercase"
          fontSize="11px"
          color={colors.AccentGreen}
        >
          New!
        </Span>
      )}
      {children}
    </>
  );
};

export default WithNewLabel;
